import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiClient from '../api/apiClient';
import { API_ENDPOINTS } from '../api/endpoints';

// Async thunk for fetching subjects
export const fetchSubjects = createAsyncThunk(
  'subjects/fetchSubjects',
  async (_, { rejectWithValue }) => {
    try {
      console.log('Fetching subjects from:', API_ENDPOINTS.GET_SUBJECT_EXPERTISE);
      const response = await apiClient({
        url: API_ENDPOINTS.GET_SUBJECT_EXPERTISE,
        method: 'get',
        withAuth: true,
      });
      
      console.log('Subjects API response:', response);
      console.log('Subjects data:', response?.data);
      
      // The API returns data directly in response.data, not response.data.subjectExpertise
      const subjectsData = response?.data?.data?.flatMap((category) => 
        category.items?.map((item) => ({
          label: item.name,
          value: item.id.toString(),
        })) || []
      ) || [];
      
      console.log('Processed subjects:', subjectsData);
      return subjectsData;
    } catch (error) {
      console.error('Subjects fetch error:', error);
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch subjects');
    }
  }
);

const subjectsSlice = createSlice({
  name: 'subjects',
  initialState: {
    data: [],
    loading: false,
    error: null,
    lastFetched: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSubjects.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.lastFetched = Date.now();
        state.error = null;
      })
      .addCase(fetchSubjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default subjectsSlice.reducer;
